import {Type} from '@angular/core';

import {BaseFilter} from './base/base.filter';

export class GeoPlaceFilter extends BaseFilter {
    public description: string;
    public geoCountyId: string;

    public constructor() {
        super();
    }

    protected getType(): Type<BaseFilter> {
        return GeoPlaceFilter;
    }
}
